import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Loading from './Loading';
import Share from './Share';
import { addPicture, deletePicture } from '../../../utils/Api';

class Item extends React.Component {
  constructor(props) {
    super(props);

    const { picture } = props;
    this.state = {
      isLoaded: true,
      modal: false,
      picture,
      errorMessage: '',
    };

    this.filesSizeLimit = 5242880; // 5 MB

    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  toggle() {
    const { modal } = this.state;
    const { picture } = this.props;
    this.setState({ modal: !modal, picture });
  }

  handleChange({ target }) {
    this.setState({ picture: target.value });
  }

  handleAdd({ target }) {
    const { id, onDelete } = this.props;
    if (target.files[0].size > this.filesSizeLimit) {
      this.setState({
        errorMessage: this.props.intl.formatMessage({
          id: 'error_filesizeExceeded',
        }),
      });
      return;
    }
    this.setState({
      isLoaded: false,
      errorMessage: null,
    });

    addPicture(id, target.files[0]).then(() => {
      this.setState({ isLoaded: true, modal: false, picture: {} });
      onDelete();
    });
  }

  handleDelete(e) {
    e.stopPropagation();
    const { intl, id, onDelete } = this.props;
    if (window.confirm(intl.formatMessage({ id: 'notes_youSure' }))) {
      this.setState({ isLoaded: false });
      deletePicture(id).then(() => {
        this.setState({ modal: false });
        onDelete();
      });
    }

    return false;
  }

  render() {
    const { isLoaded, modal, picture } = this.state;
    const { permissions, actionType, locale, id } = this.props;

    return (
      <React.Fragment>
        {actionType === 'add' ? (
          [
            <Input
              id="attachment"
              type="file"
              onChange={this.handleAdd}
              style={{ position: 'absolute', top: -1000 }}
              accept=".png, .jpeg, .jpg, .gif"
              disabled={!permissions.includes('LESSON_MY_PICTURES_ADD')}
            />,
            <button
              type="button"
              className="tile_link completed"
              onClick={() => {
                const fileUploadInput = document.getElementById('attachment');
                return fileUploadInput.click();
              }}
              disabled={!permissions.includes('LESSON_MY_PICTURES_ADD')}
            >
              <span>
                {/* <i className="fa fa-image fa-5x" /> */}
                <i className="icon_c_xl icon_c_bg icon_image_add" />
                {/* <i
                  className="fa fa-plus fa-3x"
                  style={{ position: "relative", top: "50%" }}
                /> */}
              </span>
              <Modal isOpen={modal} toggle={this.toggle} className="modal-lg">
                {!isLoaded && <Loading />}
                <ModalHeader toggle={this.toggle}>
                  <FormattedMessage id="pictures_header_title" />
                </ModalHeader>
                <ModalBody>
                  <p style={{ textAlign: 'center' }}>
                    <img
                      src={`${picture.file_link}` || ''}
                      alt={picture.original_name || ''}
                      style={{ maxWidth: '100%', maxHeight: 480 }}
                    />
                  </p>
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="danger"
                    style={{ position: 'absolute', left: 17 }} // TODO: get rid of position:absolute
                    onClick={this.handleDelete}
                    disabled={
                      !permissions.includes('LESSON_MY_PICTURES_DELETE')
                    }
                  >
                    <FormattedMessage id="overall_input_delete" />
                  </Button>
                  <Button color="secondary" onClick={this.toggle}>
                    <FormattedMessage id="overall_input_close" />
                  </Button>
                </ModalFooter>
              </Modal>
            </button>,
          ]
        ) : (
          <button
            type="button"
            className={
              actionType === 'add' ? 'btn btn-primary' : 'tile_link completed'
            }
            onClick={this.toggle}
          >
            <p className="img_preview" style={{ marginTop: '3px' }}>
              <img
                src={`${picture.file_link}?w=${256}&h=${256}` || ''}
                alt={picture.original_name || ''}
                style={{ maxWidth: '100%', maxHeight: '100%' }}
              />
            </p>
            <div
              style={{ position: 'absolute', bottom: '10px', left: '10px' }}
              onClick={this.handleDelete}
              disabled={!permissions.includes('LESSON_MY_PICTURES_DELETE')}
            >
              {/* <i className="fa fa-trash fa-2x" /> */}
              <i className="icon_c icon_c_bg icon_delete" />
            </div>
            <div
              style={{ position: 'absolute', bottom: '10px', right: '10px' }}
            >
              <Share
                key={locale}
                message={{ storage_id: picture.storage_id, shared: true, text: ' ' }}
              />
            </div>
            <Modal isOpen={modal} toggle={this.toggle} className="modal-lg">
              {!isLoaded && <Loading />}
              <ModalHeader toggle={this.toggle}>
                <FormattedMessage id="pictures_header_title" />
              </ModalHeader>
              <ModalBody>
                <p style={{ textAlign: 'center' }}>
                  <img
                    src={`${picture.file_link}` || ''}
                    alt={picture.original_name || ''}
                    style={{ maxWidth: '100%', maxHeight: 480 }}
                  />
                </p>
              </ModalBody>
              <ModalFooter>
                {actionType === 'update' && (
                  <React.Fragment>
                    <Button
                      color="danger"
                      style={{ position: 'absolute', left: 17 }} // TODO: get rid of position:absolute
                      onClick={this.handleDelete}
                      disabled={
                        !permissions.includes('LESSON_MY_PICTURES_DELETE')
                      }
                    >
                      <FormattedMessage id="overall_input_delete" />
                    </Button>
                    <Button color="secondary" onClick={this.toggle}>
                      <FormattedMessage id="overall_input_close" />
                    </Button>
                  </React.Fragment>
                )}
              </ModalFooter>
            </Modal>
          </button>
        )}
      </React.Fragment>
    );
  }
}

Item.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  id: PropTypes.number.isRequired,
  picture: PropTypes.objectOf(PropTypes.any).isRequired,
  actionType: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
};

export default injectIntl(Item);



// WEBPACK FOOTER //
// ./src/views/_Lessons/Pictures/Item.js